import React from 'react';
import styles from './CopyIco.module.scss';
import { ReactComponent as CopyIcoSVG } from '../../../assets/copy-ico.svg';

interface ICopyIcoProps {
    value: string;
}

export const CopyIco = ({ value }: ICopyIcoProps) => {
    const onCopy = async () => {
        await navigator.clipboard.writeText(value);
    };

    return (
        <div className={styles.button} onClick={onCopy}>
            <CopyIcoSVG />
        </div>
    );
};
